// extracted by mini-css-extract-plugin
module.exports = {"paneTwo":"style_paneTwo__1I3vz","inputNumberHeight":"style_inputNumberHeight__3WCNl"};